// A "?" help affordance whose tooltip is rendered in a body-level portal with fixed positioning,
// so it can spill OUT of scrolling / overflow-hidden containers (the Billing Review table wrapper
// would clip a normally positioned tooltip). Same look as the Billing app's HelpTip.

import React, { useRef, useState } from 'react';
import { createPortal } from 'react-dom';

export default function HelpTip({ text }) {
  const ref = useRef(null);
  const [tip, setTip] = useState(null);   // { top, left } in viewport coords, or null
  const open = () => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    setTip({ top: r.top - 8, left: r.left + r.width / 2 });
  };
  const close = () => setTip(null);
  return (
    <span
      ref={ref}
      className="cbc-help"
      tabIndex={0}
      aria-label={text}
      onMouseEnter={open}
      onMouseLeave={close}
      onFocus={open}
      onBlur={close}
      // It can sit inside a toggle's <label>: clicking the "?" must not flip the toggle.
      onClick={e => { e.preventDefault(); e.stopPropagation(); }}
    >
      <span className="cbc-help-mark" aria-hidden="true">?</span>
      {tip && createPortal(
        <span className="cbc-help-bubble" role="tooltip" style={{ top: tip.top, left: tip.left }}>
          {text}
        </span>,
        document.body
      )}
    </span>
  );
}
